import { Routes, Route } from 'react-router-dom';

import Books from './pages/Books';
import Ebooks from './pages/Ebooks';
import Login from './pages/Login';
import Home from './pages/Home';
import ReaderFile from './pages/ReaderFile';
import VerifyLogin from "./components/Auth/VerifyLogin";
import UsersList from "./pages/UsersList";
import CommonQuestions from "./pages/CommonQuestions";
import Categories from './pages/Categories';
import AppContent from './pages/AppContent';

export default function Router({ setShowHeader }) {
  return (
    <Routes>
      <Route path="/" element={
        <VerifyLogin>
          <Home setHeader={setShowHeader} />
        </VerifyLogin>
      }></Route>
      <Route path="/login" element={<Login setHeader={setShowHeader} />}></Route>
      <Route path="/E-books" element={
        <VerifyLogin>
          <Ebooks setHeader={setShowHeader} />
        </VerifyLogin>
      }></Route>
      {/* <Route path="/books" element={
        <VerifyLogin>
          <Books setHeader={setShowHeader} />
        </VerifyLogin>
      }></Route> */}
      <Route path="/reader/:bookId" element={<ReaderFile setHeader={setShowHeader} />}></Route>
      <Route path="/users" element={
        <VerifyLogin>
          <UsersList setHeader={setShowHeader} />
        </VerifyLogin>
      }></Route>
      <Route path="/common_questions" element={
        <VerifyLogin>
          <CommonQuestions setHeader={setShowHeader} />
        </VerifyLogin>
      }></Route>
      <Route path="/categories" element={
        <VerifyLogin>
          <Categories setHeader={setShowHeader} />
        </VerifyLogin>
      }></Route>
      <Route path="/appcontent" element={
        <VerifyLogin>
          <AppContent setHeader={setShowHeader} />
        </VerifyLogin>
      }></Route>
    </Routes>
  );
}